// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Box, Button, Flex, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Dialog, Icon, Lottie, Tag } from "components"

// Hooks
import { useOrder } from "hooks"
import { API } from "config"
import { useQueryClient } from "@tanstack/react-query"
import { Enums } from "config"

export default function Init({ data, step, setStep, pendingQuantity = null }){

    const order = useOrder(data?.id)
    const confirm = useDisclosure()
    const isInitialized = order.data?.status === Enums.OrderStatus.MONTAGE

    return(
    <>
    <Flex maxW="40%" justifyContent="center" alignItems="center" direction="column" margin="30px auto">
        <Lottie animation="waiting" style={{ width: 150, height: 150 }} options={{ loop: true }} />
        <Text fontSize="lg" fontWeight="bold" children="Iniciar montagem do pedido" />
        <Text color="GrayText" textAlign="center">Clique no botão abaixo para começar a montagem. O status será atualizado para <b>Em Preparação</b> e, se houver itens faltantes, um <b>Pedido de Pendência</b> será gerado automaticamente.</Text>
        <Button children="Iniciar montagem do pedido" mt={4} rightIcon={<Icon name="right" />} colorScheme="orange" onClick={confirm.onOpen} isDisabled={order.isFetching}  />
    </Flex>

    {/* Confirm */}
    <ConfirmAlert {...confirm} data={order.data} onSuccess={order.refetch} pendingQuantity={pendingQuantity} />
    </>
    )
}

const ConfirmAlert = ({ data, onSuccess = () => {}, pendingQuantity = null, ...props }) => {

    const toast = useToast()
    const queryClient = useQueryClient()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        if(!window.confirm('Certeza que deseja continuar?')) return
        setLoading(true)

        const pendingQuantityFiltered = (pendingQuantity !== null) ? Object.fromEntries(Object.entries(pendingQuantity).filter(([key, value]) => value?.pendingQuantity > 0)) : null;

        try{
            await API.put(`/orders/${data?.id}/montage/init`, { pendingQuantity: pendingQuantityFiltered })
            toast({ title: 'A montagem do pedido foi iniciada', status: 'success' })
            queryClient.invalidateQueries('w-orders')
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível iniciar a montagem.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <Dialog loading={loading} title={`Iniciar a preparação do pedido #${data?.cod}?`} {...props}>
        <AlertDialogBody fontSize="sm">
            Ao confirmar esta ação, você estará iniciando a preparação deste pedido. Este processo é irreversível e todas as etapas devem ser seguidas conforme especificado no sistema.
            <br /><br />
            Para o cliente, o status do pedido será alterado de <Tag size="sm" children="Aprovado" colorScheme="teal" /> para <Tag size="sm" children="Em preparação" colorScheme="orange" />.
        </AlertDialogBody>
        <AlertDialogFooter>
            <Button w="100%" children="Iniciar montagem" colorScheme="orange" rightIcon={<Icon name="right" />} isLoading={loading} onClick={handleSubmit} />
        </AlertDialogFooter>
    </Dialog>
    )
}
